// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import App from './App';
import initializeArrayFunctions from './utils/ArrayFunctions'
import Store from './store';
import router from './router';
import lodash from 'lodash';
import VModal from 'vue-js-modal';
import cookies from 'js-cookie';
import axios from 'axios';
import Clipboard from 'v-clipboard';
import './plugins/fb-sdk';
import FBSignInButton from 'vue-facebook-signin-button';
import './assets/fonts/pe-icon-7/css/pe-icon-7-stroke.css';
import './assets/fonts/pe-icon-7/css/pe-icon-7-filled.css';
import './assets/fonts/pe-icon-7/css/helper.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import modernizr from 'modernizr';
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import VueAmplitude from 'vue-amplitude';
import Constants from "./plugins/Constants";
import vSelect from 'vue-select';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueTour from 'vue-tour';
import 'swiper/css/swiper.css';
import VueMasonry from 'vue-masonry-css'

Object.defineProperty(Vue.prototype, '$lodash', { value: lodash });
Vue.config.productionTip = false;
window.Modernizr = modernizr;

var SocialSharing = require('vue-social-sharing');
require('vue-tour/dist/vue-tour.css')

Vue.use(require('vue-moment'));
Vue.use(BootstrapVue);
Vue.use(Clipboard);
Vue.use(Constants);
Vue.use(FBSignInButton);
Vue.use(modernizr);
Vue.use(SocialSharing);
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });
Vue.use(VueAmplitude, { apiKey: process.env.AMPLITUDE_API_KEY });
Vue.use(VueAwesomeSwiper);
Vue.use(VueMasonry);
Vue.use(VueTour);

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTwitter, faFacebookF, faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faFacebook,
  faFacebookF,
  faInstagram,
  faTwitter
)

vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('i', { class: { 'pe-7s-close': true, 'close-icon': false } }, ''),
  },
  OpenIndicator: {
    render: createElement => createElement('i', { class: { 'pe-7s-angle-down': true } }, ''),
  },
});

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('Slick', Slick);
Vue.component('v-select', vSelect);

const token = cookies.get('_us_token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

export const bus = new Vue();

/* eslint-disable no-new */
new Vue({
  created() {
    AOS.init();
    initializeArrayFunctions();
  },
  el: '#app',
  store: Store,
  router,
  components: {
    App
  },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js